export default __webpack_public_path__ + "static/media/12-inactive.fbe6422c.svg";